// go-chat-duplication
export class GoConnectionLostToChatSessionError extends Error {

}
